import { memo } from "react";
import styled from "styled-components";
import { Modal, Input, Button } from "antd";
import { useAtom } from "jotai";
import FormItemWrapper from "~/components/common/FormItemWrapper/FormItemWrapper";
import {
  phoneNumberSearchAtom,
  projectNameSearchAtom,
  filterPhoneNumberAtom,
  filterProjectNameAtom,
  showFilterPopupAtom,
} from "../store";

const FilterPopup = () => {
  const [showPopup, setShowPopup] = useAtom(showFilterPopupAtom);
  const [phoneNumber, setPhoneNumber] = useAtom(phoneNumberSearchAtom);
  const [projectName, setProjectName] = useAtom(projectNameSearchAtom);
  const [, setFilterPhoneNumber] = useAtom(filterPhoneNumberAtom);
  const [, setFilterProjectName] = useAtom(filterProjectNameAtom);

  const handleSearch = () => {
    setFilterPhoneNumber(phoneNumber);
    setFilterProjectName(projectName);
    setShowPopup(false);
  };

  const handleCancel = () => {
    setShowPopup(false);
  };

  return (
    <Modal
      title="Lọc dự án"
      open={showPopup}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Hủy
        </Button>,
        <Button key="search" type="primary" onClick={handleSearch}>
          Tìm kiếm
        </Button>,
      ]}
    >
      <UI_Content>
        <FormItemWrapper label="SĐT" labelWidth={80}>
          <Input
            value={phoneNumber}
            placeholder="Số điện thoại"
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
        </FormItemWrapper>
        <FormItemWrapper label="Tên dự án" labelWidth={80}>
          <Input
            value={projectName}
            placeholder="Tên dự án"
            onChange={(e) => setProjectName(e.target.value)}
          />
        </FormItemWrapper>
      </UI_Content>
    </Modal>
  );
};

export default memo(FilterPopup);

const UI_Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
`;